<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script setup>
// import { handleThemeStyle } from "@/utils/theme.js"
// let colorArr = [{
//   name: "orange_red",
//   value: "#D66530",
// },
// {
//   name: "gold",
//   value: "#D6A21D",
// },
// {
//   name: "yellow",
//   value: "#D8BF19",
// },
// {
//   name: "lime",
//   value: "#8BBE1C",
// },
// {
//   name: "cyan",
//   value: "#15AEAE",
// },
// {
//   name: "blue",
//   value: "#1653DC",
// },
// {
//   name: "purple",
//   value: "#652BB5",
// },
// {
//   name: "pink_purple",
//   value: "#F756A9",
// },
// {
//   name: "magenta",
//   value: "#d42d89",
// },
// {
//   name: "grey",
//   value: "#767E88",
// }]
// let setColor = () => {
//   colorArr.forEach(item => {
//     handleThemeStyle(item.value, item.name)
//   })
// }
onMounted(() => {
  // setColor()
})
</script>
<style>
.app-container {
  width: 100%;
  height: 100%;
  min-width: 1280px;
  padding: 0;
  margin: 0;
}
</style>
